import { FocusTrap } from './lib/focus-trap.js';
customElements.define('cipublic-focus-trap', FocusTrap);
//# sourceMappingURL=cipublic-focus-trap.js.map